import { useEffect } from "react"

// Custom hook for window resize event
function useWindowResize(handleResize: HandleResizeType) {
  useEffect(() => {
    // Handler to call on window resize
    function onResize() {
      handleResize(typeof window === "undefined" ? null : window.innerWidth)
    }

    // Add event listener
    window.addEventListener("resize", onResize)

    // Call handler right away so state gets updated with initial window size
    onResize()

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", onResize)
  }, [handleResize]) // Empty array ensures that effect is only run on mount and unmount
}

export default useWindowResize
